// 業務用語ラベルのヘルパー（2026-05-14 追加）
//
// 収入・支出の取引種別に応じて表示文言を切り替えるための共通関数。
// DB スキーマ上は cell_meta.due_date として 1 カラムに統合しているが、
// UI 上は業務用語として「入金期日（収入）」「支払期限（支出）」と
// 切り替えて表示する。一覧の列ヘッダ等、種別が混在する場面は
// DUE_DATE_COLUMN_LABEL を使う。

export type TxType = 'income' | 'expense'

/**
 * 取引種別に応じた期日ラベル。
 * - 収入: 入金期日
 * - 支出: 支払期限
 * - 不明（null/undefined）: 「期日」を返す（中立表現）
 */
export function dueDateLabel(type: TxType | null | undefined): string {
  if (type === 'income') return '入金期日'
  if (type === 'expense') return '支払期限'
  return '期日'
}

/** 一覧の列ヘッダなど、収入と支出が混在する場面で使う統合ラベル */
export const DUE_DATE_COLUMN_LABEL = '入金/支払期日'
